import React from "react";

function ProfileInfoSkeleton() {
  return <div>ProfileInfoSkeleton</div>;
}

export default ProfileInfoSkeleton;
